module.exports = __webpack_public_path__ + "static/media/empties.46715545.png";